import React, { useContext, useEffect } from 'react';
import styles from './index.module.scss';
import { ShareDataUnityPowerMapContext, IndexTimeActive } from '../../../..';
import { getDefaultTime } from '@/pages/WgqAllMaps/utils';
import {
  apiV2ElectricMapDataElectricityOverviewPost,
  V2ElectricMapDataElectricityOverviewPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { Spin } from 'antd';
import { keepOneAndWan, keepOneAndWanOrLine } from '@/utils/utils';
import { Button } from '@maxtropy/components';
import { DoubleRightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { isNil } from 'lodash-es';
import qs from 'qs';

const PeakValleyRight = () => {
  const { timeResolution: activeKey, dateValue: value, configDetail } = useContext(ShareDataUnityPowerMapContext);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [originData, setOriginData] = React.useState<V2ElectricMapDataElectricityOverviewPostResponse>();
  const [energyStr, setEnergyStr] = React.useState<string>('');

  useEffect(() => {
    if (!value || !activeKey) return;
    setLoading(true);
    apiV2ElectricMapDataElectricityOverviewPost({
      timeResolution: activeKey === IndexTimeActive.THIS_MONTH ? 'M' : 'Y',
      start: getDefaultTime(activeKey, value).startTime,
      end: getDefaultTime(activeKey, value).endTime,
    })
      .then(res => {
        setOriginData(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [activeKey, value]);

  useEffect(() => {
    import('@maxtropy/device-customer-apis-v2').then(({ apiV2ElectricMapConfigOverviewHighConsumptionDetailPost }) => {
      apiV2ElectricMapConfigOverviewHighConsumptionDetailPost({}).then(res => {
        let str = '';
        if (!isNil(res?.energyUnitGroupId)) {
          str += `energyGroupId=${res?.energyUnitGroupId}`;
        }
        if (!isNil(res?.energyUnitId)) {
          str += `&unitId=${res?.energyUnitId}`;
        }
        setEnergyStr(str);
      });
    });
  }, []);

  const routeStr = React.useMemo(() => {
    if (activeKey === IndexTimeActive.THIS_YEAR) {
      return '&currentYear=true';
    } else {
      const startDate = dayjs().subtract(1, 'day').startOf('month').format('YYYYMMDD');
      const endDate = dayjs().subtract(1, 'day').endOf('day').format('YYYYMMDD');
      return `&currentYear=false&startDate=${startDate}&endDate=${endDate}`;
    }
  }, [activeKey]);

  return (
    <Spin spinning={loading}>
      <div className={styles.container}>
        {/* 日期显示和用能流向按钮在同一行 */}
        <div className={styles.headerRow}>
          <span style={{ color: '#4A90E2' }}>
            {dayjs(value).format(activeKey === IndexTimeActive.THIS_MONTH ? 'YYYY-MM' : 'YYYY')}
          </span>
          <Button
            type="link"
            onClick={() => {
              window.open(
                `/energy/analysis/unitSankey?${qs.stringify(
                  {
                    radioType: activeKey === IndexTimeActive.THIS_MONTH ? 1 : 2,
                    fromTime: dayjs(getDefaultTime(activeKey!, value)?.startTime).format('YYYY-MM-DD'),
                    toTime: dayjs(getDefaultTime(activeKey!, value)?.endTime).format('YYYY-MM-DD'),
                    unitGroupId: configDetail?.energyGroupId,
                  },
                  { indices: false }
                )}`,
                '_blank'
              );
            }}
          >
            用能流向
            <DoubleRightOutlined className="translationStyles" />
          </Button>
        </div>

        <div className={styles.leftCard}>
          <div className={styles.outerCircle}>
            <div className={styles.rotateRing}></div>
            <div className={styles.innerDiamonds}></div>
          </div>
          <div className={styles.info}>
            <div className={styles.row}>
              <div className={styles.label}>总-{activeKey === IndexTimeActive.THIS_YEAR ? '月均' : '日均'}(kWh)</div>
              <div className={styles.artistic}>{keepOneAndWanOrLine(originData?.totalAvg)}</div>
              <Button
                type="link"
                style={{ padding: 4 }}
                onClick={() => {
                  window.open(`${window.ENERGY}/layout/home?${energyStr}${routeStr}&activeKey=2030`, '_blank');
                }}
              >
                <DoubleRightOutlined />
              </Button>
            </div>
          </div>
        </div>
        <div className={styles.itemRow}>
          <div className={styles.itemCard}>
            <div style={{ color: '#FF6D2C' }}>尖-{activeKey === IndexTimeActive.THIS_YEAR ? '月均' : '日均'}(kWh)</div>
            <div className={styles.keyVal}>
              {keepOneAndWan(originData?.summitAvg).value}
              <span className={styles.unit}>{keepOneAndWan(originData?.summitAvg).unit}</span>
            </div>
          </div>
          <div className={styles.itemCard}>
            <div style={{ color: '#CE90D1' }}>峰-{activeKey === IndexTimeActive.THIS_YEAR ? '月均' : '日均'}(kWh)</div>
            <div className={styles.keyVal}>
              {keepOneAndWan(originData?.peakAvg).value}
              <span className={styles.unit}>{keepOneAndWan(originData?.peakAvg).unit}</span>
            </div>
          </div>
        </div>
        <div className={styles.itemRow}>
          <div className={styles.itemCard}>
            <div style={{ color: '#0DB6D9' }}>平-{activeKey === IndexTimeActive.THIS_YEAR ? '月均' : '日均'}(kWh)</div>
            <div className={styles.keyVal}>
              {keepOneAndWan(originData?.plainAvg).value}
              <span className={styles.unit}>{keepOneAndWan(originData?.plainAvg).unit}</span>
            </div>
          </div>
          <div className={styles.itemCard}>
            <div style={{ color: '#63BC7F' }}>谷-{activeKey === IndexTimeActive.THIS_YEAR ? '月均' : '日均'}(kWh)</div>
            <div className={styles.keyVal}>
              {keepOneAndWan(originData?.valleyAvg).value}
              <span className={styles.unit}>{keepOneAndWan(originData?.valleyAvg).unit}</span>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default PeakValleyRight;
